import uirouter from 'angular-ui-router';
import routing from './subscriberForm.routes';
import SubscriberFormCtrl from './controllers/index';
import SubscriberFormEmailCtrl from './controllers/email';
import SubscriberFormSettingsCtrl from './controllers/settings';
import SubscriberFormBuilderCtrl from './controllers/editSubscriberForm';
import SubscriberFormSummaryCtrl from './controllers/summary';
import subscriberFormPreview from './directives/subscriberFormPreview';
import subscriberFormTopMenu from './directives/subscriberFormTopMenu';
import subscriberFormHtmlGenerator from './directives/subscriberFormHtmlGenerator';
import SubscriberForm from './subscriberForm.repository.js';

export default angular.module('app.subscriberForm', [uirouter])
    .config(routing)
    .controller('SubscriberFormCtrl', SubscriberFormCtrl)
    .controller('SubscriberFormBuilderCtrl', SubscriberFormBuilderCtrl)
    .controller('SubscriberFormEmailCtrl', SubscriberFormEmailCtrl)
    .controller('SubscriberFormSettingsCtrl', SubscriberFormSettingsCtrl)
    .controller('SubscriberFormSummaryCtrl', SubscriberFormSummaryCtrl)
    .directive('subscriberFormPreview', () => new subscriberFormPreview)
    .directive('subscriberFormTopMenu', () => new subscriberFormTopMenu)
    .directive('subscriberFormHtmlGenerator', () => new subscriberFormHtmlGenerator)
    .service('SubscriberForm', SubscriberForm)
    .name;